import React from 'react';
import { Link } from 'react-router-dom';
import API_CONFIG from "../config/api";
import './PopularCourses.css';
// import mathimg from "../assets/Group 22.png";
// import codingimg from "../assets/Rectangle 5.png";
// import graphicimg from "../assets/Rectangle 5-1.png";
// import quranimg from "../assets/Group 22-1.png";
// import businessimg from "../assets/Group 22-2.png";
// import spaceimg from "../assets/Group 22-6.png";
// import communicationimg from "../assets/Rectangle 5-2.png";
// import architectureimg from "../assets/Group 22-4.png";
// import engineeringimg from "../assets/Group 22-3.png";
// import art from "../assets/Group 22-5.png";
import pencilIcon from "../assets/pencil.png";
// import icon1 from "../assets/Icons (6).png"
// import icon2 from "../assets/Icons (3).png"
// import icon3 from "../assets/Icons (7).png"
// import icon4 from "../assets/Icons (5).png"
// import icon5 from "../assets/Icons (8).png"
// import icon6 from "../assets/Icons (9).png"
// import icon7 from "../assets/Icons (4).png"
// import icon8 from "../assets/Icons (2).png"
// import icon9 from "../assets/Icons (1).png"
// import icon10 from "../assets/Icons (10).png"



const PopularCourses = () => {
  const courses = [
    {
      id: 1,
      title: "Math's Portal",
      image: "Polymath-images/Menu Pages/Group 22.png",
      icon: "Polymath-images/Menu Pages/Icons (6).png",
      color: "#FF3366",
      age: "Age: 12+",
      link: "/abacus_home"
    },
    {
      id: 2,
      title: "Coding & Technology",
      image: "Polymath-images/Menu Pages/Group 22-1.png",
      icon: "Polymath-images/Menu Pages/Icons (3).png",
      color: "#9933FF",
      age: "Age: 12+",
      link: "/coding_home"
    },
    {
      id: 3,
      title: "Graphic Design & Creativity",
      image: "Polymath-images/Menu Pages/Group 22-2.png",
      icon: "Polymath-images/Menu Pages/Vector-2.png",
      color: "#33B5E5",
      age: "Age: 12+",
      link: "/graphic_designing_portal"
    },
    {
      id: 4,
      title: "Quran & Islamic Studies",
      image: "Polymath-images/Menu Pages/Rectangle 5.png",
      icon: "Polymath-images/Menu Pages/Group 1686551984.png",
      color: "#00C851",
      age: "Age: 12+",
      link: "/quran_portal"
    },
    {
      id: 5,
      title: "Business & Entrepreneurship",
      image: "Polymath-images/Menu Pages/Group 22-3.png",
      icon: "Polymath-images/Menu Pages/Vector.png",
      color: "#FF8800",
      age: "Age: 12+",
      link: "/business_portal"
    },
    {
      id: 6,
      title: "Engineering & Technology",
      image: "Polymath-images/Menu Pages/Rectangle 5-1.png",
      icon: "Polymath-images/Menu Pages/Vector-1.png",
      color: "#2BBBAD",
      age: "Age: 12+",
      link: "/engineering_portal"
    },
    {
      id: 7,
      title: "Architecture & Interior Design",
      image: "Polymath-images/Menu Pages/Rectangle 5-2.png",
      icon: "Polymath-images/Menu Pages/Group 1686551982.png",
      color: "#E91E63",
      age: "Age: 12+",
      link: "/arch_interior_design"
    },
    {
      id: 8,
      title: "Communication & Public Speaking",
      image: "Polymath-images/Menu Pages/Rectangle 5-3.png",
      icon: "Polymath-images/Menu Pages/Group 1686551979.png",
      color: "#4285F4",
      age: "Age: 12+",
      link: "/comm_skills_portal"
    },
    {
      id: 9,
      title: "Space Sciences",
      image: "Polymath-images/Menu Pages/Group 22-5.png",
      icon: "Polymath-images/Menu Pages/Vector-3.png",
      color: "#AA66CC",
      age: "Age: 12+",
      link: "/space_sc_portal"
    },
    {
      id: 10,
      title: "Art Courses",
      image: "Polymath-images/Menu Pages/Group 22-4.png",
      icon: "Polymath-images/Menu Pages/Vector-2.png",
      color: "#AA66CC",
      age: "Age: 12+",
      link: null
    }
  ];
  return (
    <div className="stem-container">
      <h1 className="stem-title">Our Popular Stem Courses</h1>
      <div className="courses-grid">
        {courses.map((course) => (
          <div key={course.id} className="course-card">
            <Link to={course.link} className="course-link">

              <div className="course-image-container">
                <img
                  src={`${API_CONFIG.IMAGES_URL}/${course.image}`}
                  alt={course.title}

                  className="course-image"
                />
                <span className="ages-badge">{course.age}</span>
              </div>

              <div className="icon-container" style={{ backgroundColor: course.color }}>
                <img src={`${API_CONFIG.IMAGES_URL}/${course.icon}`} alt={`${course.title} icon`} className="course-icon" />
              </div>

              <p className="course-title">{course.title}</p>
            </Link>
          </div>
        ))}
      </div>
      <button className="pocustom-btn yellow-btn">
        <img src={pencilIcon} alt="icon" className="pobtn-icon" />
        Book Free Demo Class
      </button>
    </div>
  );
};

export default PopularCourses;